<template>
<div class="bg-gray-100">
    <div class="vld-parent">
      <loading :active="isLoading" :is-full-page="true"/>
  </div>
  <Hero/>
  
  <!-- Filter block -->
  <section id="filter-section" class="container shadow-md mx-auto px-6 pb-8 pt-2 bg-white">
    <div class="lg:grid lg:grid-cols-4 gap-x-8 md:items-end">
      <div class="col lg:mb-0 mb-2">
        <h2 class="text-xl font-display font-bold my-6">Szukaj</h2>
        <div class="block relative">
          <span class="h-full absolute inset-y-0 left-0 flex items-center pl-2">
            <svg viewBox="0 0 24 24" class="h-4 w-4 fill-current text-gray-500">
              <path
                d="M10 4a6 6 0 100 12 6 6 0 000-12zm-8 6a8 8 0 1114.32 4.906l5.387 5.387a1 1 0 01-1.414 1.414l-5.387-5.387A8 8 0 012 10z">
              </path>
            </svg>
          </span>
          <input v-model="filterFreetext"
                 placeholder="Wyszukaj po autorze"
                 class="appearance-none rounded border border-gray-300 block pl-8 pr-6 py-2 w-full bg-white text-sm placeholder-gray-400 text-gray-700 focus:bg-white focus:placeholder-gray-600 focus:text-gray-700 focus:outline-none hover:border-fuchsia-500" />
        </div>
      </div>
      <div class="col lg:mb-0 mb-2">
        <Multiselect
          v-model="selection.time"
          mode="tags"
          placeholder="Okres historyczny"
          :options="filtersTime"
          :closeOnSelect="true"
          :searchable="false"
          />
      </div>
      
      <div class="col">
        <Multiselect
          v-model="selection.kind"
          mode="tags"
          placeholder="Rodzaj przemówienia"
          :options="filtersKind"
          :closeOnSelect="true"
          :searchable="false"
          />
      </div>
      
      <div class="col">
        <h2 class="text-xl font-display font-bold my-6">Sortuj</h2>
        <div class="relative">
          <select
            v-model="sort.selected"
            class="appearance-none h-full rounded border w-full bg-white border-gray-300 text-gray-700 py-2 px-4 pr-8 leading-tight focus:outline-none hover:border-fuchsia-500 ">
            <option v-for="option in sort.options" v-bind:value="option.value">
              {{ option.text }}
            </option>
          </select>
          <div
            class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
              <path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" />
            </svg>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  <div v-if="sortedItems.length >= 1" class="mx-auto py-10 grid md:grid-cols-2 lg:grid-cols-4 gap-8 px-4">
    <div v-for="entry in this.sortedItems" class="">
      <Card :entry="entry"/>
    </div>
  </div>

  <div v-else class="mx-auto w-2/3">
    <div class="mx-auto text-center mt-24 mb-12 w-full"> 
    <div class="text-3xl  text-center font-display mb-4">Brak przemówień o podanych kryteriach</div>
    <div class="text-fuchsia-500 cursor-pointer" v-on:click=cleanFilters()>Wyczyść filtry</div>
    </div>
    <div class="bg-white mt-10 mb-40 p-4 rounded-3xl ">
    <Newsletter is-missing />
  </div>
  </div>
</div>
</template>

<script>
import Card from '../components/Card.vue'
import Newsletter from '../components/Newsletter.vue'
import Hero from '../components/Hero.vue'
import Multiselect from '@vueform/multiselect/dist/multiselect.vue2'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

export default {
    name: 'Timeline',
    data() {
        return {
            entries: null,
            isLoading: true,
            sort:{
                selected: 'newFirst',
                options: [
                    { text: 'Od wypowiedzianych najwcześniej', value: 'newFirst' },
                    { text: 'Od wypowiedzianych najpóźniej', value: 'oldFirst' },
                ]
            },
            filterFreetext: null,
            selection:{
                kind: [],
                time: []
            },
            filtersKind: [],
            filtersTime: []
        }
    },
    methods: {
        cleanFilters(){
            this.filterFreetext = null;
            this.selection.kind = null;
            this.selection.time = null;
        },
        async getContent() {
            const response = await this.$prismic.client.query(
                this.$prismic.Predicates.at('document.type', 'entry'),
                {
                    orderings: '[document.last_publication_date]',
                    page: 0,
                    pageSize: 100
                }
            )
            this.entries = response.results
            this.populateFilters();
            this.isLoading = false;
        },
        populateFilters: function(){
            var uniqueKinds = [...new Set(this.entries.map(item => item.data.category_type))]; 
            var uniqueTimes = [...new Set(this.entries.map(item => item.data.category_time))]; 
            
            this.filtersTime = uniqueTimes.reduce(function(result, item){
                if(item != null) result.push({value: item, label: item});
                return result;
            }, [])
            this.filtersKind = uniqueKinds.reduce(function(result, item){
                if(item != null) result.push({value: item, label: item});
                return result;
            }, [])
        }
    },
    computed:{
        sortedItems(){
            var t = this;
            if(t.entries == null) return []
            
            var sorted = this.entries.sort((a,b) => 
                Date.parse(a.data.date) - Date.parse(b.data.date)
            )
            if(this.sort.selected == 'oldFirst') sorted = sorted.reverse();
            
            var prefiltered = sorted;
            
            if(this.selection.kind && this.selection.kind.length != 0){
                prefiltered = prefiltered.filter(function (e) {
                    if(e.data.category_type && t.selection.kind[0]) return t.selection.kind.some(
                        (x) => x == e.data.category_type.valueOf()
                    )
                });
            }
            
            if(this.selection.time && this.selection.time.length != 0){
                prefiltered = prefiltered.filter(function (e) {
                    if(e.data.category_time && t.selection.time[0]) return t.selection.time.some(
                        (x) => x == e.data.category_time.valueOf()
                    )
                });
            }
            
            if(t.filterFreetext){
                var filtered = prefiltered.filter(function(el){
                    if(el.data.speaker && t.filterFreetext.length > 2){
                        var author =  el.data.speaker[0].text.toLowerCase();
                        var filter = t.filterFreetext.toLowerCase();
                        return author.match(filter)
                    }else{
                        return true
                    }
                })
                if(filtered.length == 0) return []
                return filtered
            }else{
                return prefiltered;
            }
        }
    },
    created() {
        this.isLoading = true;
        this.getContent()
    },
    components:{
        Hero, Card, Multiselect, Newsletter, Loading
    }
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
